module.exports = __webpack_public_path__ + "img/icon_link@2x.69ac72fb.png";